import { useEffect } from 'react';
import { scrollbarWidth } from '@xobotyi/scrollbar-width';

import { getBodyPaddingRight, checkBodyScrollbar } from './utils';
import { publishBodyOverflowShift } from './events';

/**
 * После маунта компонента:
 * - добавляет body стили `overflow: hidden`
 * - добавляет body отступ справа, равный ширине скроллбара
 * - публикует событие (./subscribe.ts), для того чтобы другие компоненты могли на это реагировать, например менять стили
 *
 * Перед анмаунтом компонента возвращает стили `body` в изначальное состояние и публикует событие (./subscribe.ts) с 0
 * Не используется useLockBodyScroll из react-us, т.к. тот не добавляет паддинга и не оповещает другие элементы о событии.
 * Хотя вариант из react-us имеет дополнительные хаки для iOS Safari.
 */
export const useLockBodyScroll = (forceRecalculateScrollbarWidth?: boolean) => {
    useEffect(() => {
        const { overflow: initialOverflow, paddingRight: initialPaddingRight } =
            document.body.style;
        const bodyOverflowShift = scrollbarWidth(forceRecalculateScrollbarWidth);
        const bodyHasScrollbar = checkBodyScrollbar();

        if (initialOverflow !== 'hidden') {
            document.body.style.overflow = 'hidden';
        }

        if (bodyOverflowShift && bodyHasScrollbar) {
            document.body.style.paddingRight = `${getBodyPaddingRight() + bodyOverflowShift}px`;
            publishBodyOverflowShift(bodyOverflowShift);
        }

        return () => {
            const { overflow: currentOverflow } = document.body.style;

            if (bodyOverflowShift && bodyHasScrollbar) {
                document.body.style.paddingRight = initialPaddingRight;
                publishBodyOverflowShift(0);
            }

            /* istanbul ignore next */
            if (currentOverflow !== initialOverflow) {
                document.body.style.overflow = initialOverflow;
            }
        };
    }, [forceRecalculateScrollbarWidth]);
};
